import type { BatchItem } from '@api/hooks/useBatch.ts';
import { Chip, DocumentIcon, Typography } from '@gurupay/gp-ui-library';
import { batchStatusColorConfig } from '@pages/batch-operations/utils.ts';
import { formatNumberAmount } from '@utils/utils.ts';
import { useTranslation } from 'react-i18next';

interface BatchMobileItemProps {
	item: BatchItem;
}

export const BatchMobileItem = ({
	item: {
		fileName,
		status,
		uploadDate,
		operationsCount,
		totalAmount,
		resolvedAmount,
		resolvedOperationsCount,
	},
}: BatchMobileItemProps) => {
	const { t } = useTranslation('', { keyPrefix: 'payments.batch.table' });

	return (
		<div className="border border-neutral-100 rounded-lg p-space-16 gap-space-16 flex flex-col">
			<div>
				<Typography
					className="flex items-center gap-space-8 font-bold break-all"
					level="small-text"
				>
					<DocumentIcon className="text-brand-primary-600 min-w-5" /> {fileName}
				</Typography>
				<Chip
					className="capitalize mt-space-8"
					color={batchStatusColorConfig[status]}
					label={t(`paymentStatus.${status.toLowerCase()}`)}
					size="small"
					variant="filled"
				/>
			</div>

			<div className="flex flex-col">
				<Typography className="font-medium text-neutral-600" level="small-text">
					{t('uploaded')}
				</Typography>
				<Typography className="font-bold" level="small-text">
					{uploadDate}
				</Typography>
			</div>

			<div className="flex flex-col">
				<Typography className="font-medium text-neutral-600" level="small-text">
					{t('operationsCount')}
				</Typography>
				<Typography className="font-bold" level="small-text">
					{resolvedOperationsCount ?? operationsCount}
				</Typography>
			</div>

			<div className="flex flex-col">
				<Typography className="font-medium text-neutral-600" level="small-text">
					{t('totalAmount')}
				</Typography>
				<Typography className="font-bold" level="small-text">
					{formatNumberAmount((resolvedAmount ?? totalAmount).toFixed(2))}
				</Typography>
			</div>
		</div>
	);
};
